import { readPageCardGap, readPageCardGapFrom } from './railCard'

/** Marks a rail row with its area, so a card beside the rail can line up with it. */
export const RAIL_MODULE_ATTRIBUTE = 'data-rail-module'

/**
 * Measures a card's place beside the rail in GlobalSidebar's floating layer:
 * the centre of the `anchor` row's icon from the layer's top (`null` when the
 * row isn't there), the page card's top (its gap below the header), and the
 * room from there to the page card's bottom edge.
 */
export function measureRailAnchor(layer: HTMLElement, anchor: string) {
  const layerRect = layer.getBoundingClientRect()
  const gap = readPageCardGap(layer)
  // The page card's top: its gap below the header, where the layer starts.
  const top = readPageCardGapFrom(layer, 'top')
  // The icon's tile is the row's first child; the row adds the gap below it.
  const row = layer.querySelector(`[${RAIL_MODULE_ATTRIBUTE}="${anchor}"]`)
  const tileRect = (row?.firstElementChild ?? row)?.getBoundingClientRect()
  return {
    tileCenter: tileRect ? tileRect.top + tileRect.height / 2 - layerRect.top : null,
    top,
    room: Math.max(0, layerRect.height - top - gap),
  }
}
